import { en } from './locales'
import { IDictionary } from 'types'
export const dict: IDictionary = {
  en
}
